import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "wage-ssn-missing-dialog" }
const _hoisted_2 = { class: "wage-ssn-missing-dialog__header" }
const _hoisted_3 = { class: "header-icon" }
const _hoisted_4 = { class: "header-text" }
const _hoisted_5 = { class: "header-sub" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = { class: "wage-ssn-missing-dialog__body" }
const _hoisted_8 = {
  key: 0,
  class: "intro"
}
const _hoisted_9 = {
  key: 1,
  class: "state-box"
}
const _hoisted_10 = {
  key: 2,
  class: "state-box error"
}
const _hoisted_11 = {
  key: 3,
  class: "state-box ok"
}
const _hoisted_12 = {
  key: 4,
  class: "ssn-table-wrap"
}
const _hoisted_13 = { class: "ssn-table" }
const _hoisted_14 = { class: "col-name" }
const _hoisted_15 = { class: "name" }
const _hoisted_16 = { class: "birth" }
const _hoisted_17 = { class: "col-job" }
const _hoisted_18 = { class: "col-ssn" }
const _hoisted_19 = {
  key: 0,
  class: "field-done"
}
const _hoisted_20 = {
  key: 1,
  class: "ssn-input-row"
}
const _hoisted_21 = { class: "ssn-front" }
const _hoisted_22 = ["onUpdate:modelValue", "disabled", "onInput", "onKeydown"]
const _hoisted_23 = { class: "col-join" }
const _hoisted_24 = {
  key: 0,
  class: "field-done"
}
const _hoisted_25 = { class: "col-save" }
const _hoisted_26 = ["disabled", "onClick"]
const _hoisted_27 = { class: "wage-ssn-missing-dialog__footer" }
const _hoisted_28 = ["disabled"]
const _hoisted_29 = ["disabled"]
const _hoisted_30 = ["disabled"]

import { computed, reactive, ref, watch } from 'vue';
import { employeeApi } from '@/services/api';
import YmdDateInput from '@/components/common/YmdDateInput.vue';

type MissingRow = {
  clci_idx: number;
  clci_source?: string;
  clci_name?: string;
  clci_birth_date?: string;
  clci_job_type?: string;
  clci_has_ssn_back?: boolean;
  clci_work_start_date?: string | null;
};

type SavePlan = {
  ssn?: string;
  join?: string;
  /** 저장할 값이 없고, 입력이 덜 됐을 때 */
  error?: string;
  /** 다른 항목은 저장하지만, 이 입력은 빠질 때 */
  pending?: string;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'WageSsnMissingModal',
  props: {
    modelValue: { type: Boolean },
    memberCode: {},
    yearMonth: {}
  },
  emits: ["update:modelValue", "saved", "continue-magam"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const loading = ref(false);
const saving = ref(false);
const loadError = ref('');
const rows = ref<MissingRow[]>([]);
const drafts = reactive<Record<string, string>>({});
const joinDrafts = reactive<Record<string, string>>({});

const yearMonthDash = computed(() => {
  const digits = String(props.yearMonth || '').replace(/\D/g, '').slice(0, 6);
  if (digits.length !== 6) return '';
  return `${digits.slice(0, 4)}-${digits.slice(4, 6)}`;
});

const rowKey = (row: MissingRow) =>
  `${row.clci_source === 'manual' ? 'manual' : 'auto'}:${row.clci_idx}`;

const isValidSsnBack = (raw: string) => /^\d{7}$/.test(String(raw || '').replace(/\D/g, ''));

const hasJoinDate = (value?: string | null) => {
  const raw = String(value || '').slice(0, 10);
  return /^\d{4}-\d{2}-\d{2}$/.test(raw) && raw !== '0000-00-00';
};

const isValidJoinDate = (raw: string) => hasJoinDate(raw);

/** 입사일이 이 연월보다 뒤면 현원에서 빠진다 */
const leavesHyunwon = (join: string) => {
  const ym = yearMonthDash.value;
  return !!ym && join.slice(0, 7) > ym;
};

const formatBirth = (birthDate?: string | null) => {
  const raw = String(birthDate || '').slice(0, 10);
  if (!/^\d{4}-\d{2}-\d{2}$/.test(raw)) return '';
  return raw;
};

const formatSsnFront = (birthDate?: string) => {
  const raw = formatBirth(birthDate).replace(/-/g, '');
  if (raw.length !== 8) return '******';
  return raw.slice(2);
};

const ssnGapCount = computed(() => rows.value.filter((row) => !row.clci_has_ssn_back).length);
const joinGapCount = computed(
  () => rows.value.filter((row) => !hasJoinDate(row.clci_work_start_date)).length
);

const clearDrafts = () => {
  Object.keys(drafts).forEach((k) => {
    delete drafts[k];
  });
  Object.keys(joinDrafts).forEach((k) => {
    delete joinDrafts[k];
  });
};

const needsGap = (row: MissingRow) =>
  !!row?.clci_idx && (!row.clci_has_ssn_back || !hasJoinDate(row.clci_work_start_date));

const planFor = (row: MissingRow): SavePlan => {
  const key = rowKey(row);
  const plan: SavePlan = {};
  const pending: string[] = [];
  if (!row.clci_has_ssn_back) {
    const ssn = String(drafts[key] || '').replace(/\D/g, '');
    if (ssn && !isValidSsnBack(ssn)) pending.push('주민번호 뒷자리는 숫자 7자리여야 합니다.');
    else if (isValidSsnBack(ssn)) plan.ssn = ssn;
  }
  if (!hasJoinDate(row.clci_work_start_date)) {
    const join = String(joinDrafts[key] || '').trim().slice(0, 10);
    if (join && !isValidJoinDate(join)) pending.push('입사일은 YYYY-MM-DD로 입력해 주세요.');
    else if (isValidJoinDate(join)) plan.join = join;
  }
  if (pending.length) {
    if (plan.ssn || plan.join) plan.pending = pending[0];
    else plan.error = pending[0];
  }
  return plan;
};

const canSaveRow = (row: MissingRow) => {
  const plan = planFor(row);
  return !plan.error && !!(plan.ssn || plan.join);
};

const saveableCount = computed(() => rows.value.filter((row) => canSaveRow(row)).length);

const loadRows = async () => {
  if (!props.memberCode || !yearMonthDash.value) {
    rows.value = [];
    loadError.value = '시설·연월 정보가 없습니다.';
    return;
  }
  loading.value = true;
  loadError.value = '';
  clearDrafts();
  try {
    const res = await employeeApi.getList(props.memberCode, {
      yearMonth: yearMonthDash.value,
      status: '현원',
      limit: 5000,
      preferJoinDate: true,
    });
    const list = (res.data?.data?.list || []) as MissingRow[];
    rows.value = list.filter((row) => needsGap(row));
    rows.value.forEach((row) => {
      const key = rowKey(row);
      drafts[key] = '';
      joinDrafts[key] = '';
    });
  } catch (error: any) {
    rows.value = [];
    loadError.value =
      error.response?.data?.message || error.message || '미등록 목록을 불러오지 못했습니다.';
  } finally {
    loading.value = false;
  }
};

const onSsnInput = (key: string, event: Event) => {
  const input = event.target as HTMLInputElement;
  drafts[key] = String(input.value || '').replace(/\D/g, '').slice(0, 7);
};

const applySaved = (key: string, plan: SavePlan) => {
  rows.value = rows.value.flatMap((row) => {
    if (rowKey(row) !== key) return [row];
    const next: MissingRow = { ...row };
    if (plan.ssn) {
      next.clci_has_ssn_back = true;
      delete drafts[key];
    }
    if (plan.join) {
      next.clci_work_start_date = plan.join;
      delete joinDrafts[key];
      if (leavesHyunwon(plan.join)) return [];
    }
    if (next.clci_has_ssn_back && hasJoinDate(next.clci_work_start_date)) return [];
    return [next];
  });
};

const persistRow = async (row: MissingRow, plan: SavePlan) => {
  const data: Record<string, string> = {};
  if (plan.ssn) data.clci_ssn_back = plan.ssn;
  if (plan.join) data.clci_work_start_date = plan.join;
  const source = row.clci_source === 'manual' ? 'manual' : 'auto';
  await employeeApi.update(props.memberCode, row.clci_idx, data, source);
  applySaved(rowKey(row), plan);
};

const saveOne = async (row: MissingRow) => {
  const plan = planFor(row);
  if (plan.error) {
    alert(plan.error);
    return;
  }
  if (!plan.ssn && !plan.join) {
    alert('주민번호 뒷자리 또는 입사일을 입력해 주세요.');
    return;
  }
  if (!props.memberCode || saving.value) return;

  saving.value = true;
  try {
    await persistRow(row, plan);
    emit('saved');
    if (plan.pending) alert(`${plan.pending}\n나머지 항목은 저장했습니다.`);
  } catch (error: any) {
    const message = error.response?.data?.message || error.message || '저장에 실패했습니다.';
    alert(`저장 실패: ${message}`);
  } finally {
    saving.value = false;
  }
};

const saveAll = async () => {
  if (!props.memberCode || saving.value) return;
  const targets = rows.value.filter((row) => canSaveRow(row));
  if (!targets.length) {
    const partial = rows.value.find((row) => planFor(row).error);
    alert(partial ? planFor(partial).error : '저장할 주민번호 또는 입사일을 입력해 주세요.');
    return;
  }

  saving.value = true;
  let ok = 0;
  const failed: string[] = [];
  try {
    for (const row of targets) {
      const plan = planFor(row);
      try {
        await persistRow(row, plan);
        ok += 1;
      } catch {
        failed.push(row.clci_name || String(row.clci_idx));
      }
    }
    if (ok) emit('saved');
    const partials = rows.value.filter((row) => planFor(row).error);
    if (failed.length || partials.length) {
      const bits = [`${ok}명 저장`];
      if (failed.length) bits.push(`${failed.length}명 실패 (${failed.slice(0, 8).join(', ')})`);
      if (partials.length) bits.push(`${partials.length}명은 아직 입력이 덜 된 항목이 있습니다`);
      alert(bits.join('\n'));
    }
  } finally {
    saving.value = false;
  }
};

const close = () => {
  if (saving.value) return;
  emit('update:modelValue', false);
};

const continueMagam = () => {
  if (saving.value) return;
  emit('continue-magam');
};

watch(
  () => props.modelValue,
  (open) => {
    if (open) void loadRows();
  }
);

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    "model-value": __props.modelValue,
    "max-width": "860",
    persistent: "",
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (emit('update:modelValue', $event)))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_v_icon, {
              size: "18",
              color: "white"
            }, {
              default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                _createTextVNode("mdi-card-account-details-outline", -1)
              ]))]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_4, [
            _cache[3] || (_cache[3] = _createElementVNode("h2", { class: "header-title" }, "주민번호·입사일 등록 후 마감할 수 있어요", -1)),
            _createElementVNode("p", _hoisted_5, [
              (loading.value)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode("불러오는 중…")
                  ], 64))
                : (rows.value.length)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      (ssnGapCount.value)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode("주민번호 " + _toDisplayString(ssnGapCount.value) + "명", 1)
                          ], 64))
                        : _createCommentVNode("", true),
                      (ssnGapCount.value && joinGapCount.value)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode(" · ")
                          ], 64))
                        : _createCommentVNode("", true),
                      (joinGapCount.value)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                            _createTextVNode("입사일 " + _toDisplayString(joinGapCount.value) + "명", 1)
                          ], 64))
                        : _createCommentVNode("", true),
                      _cache[2] || (_cache[2] = _createTextVNode(" · 비어 있는 항목만 입력하면 됩니다 ", -1))
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _createTextVNode("미등록자가 없습니다. 마감을 이어갈 수 있습니다")
                    ], 64))
            ])
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "wage-ssn-missing-dialog__close",
            disabled: saving.value,
            "aria-label": "닫기",
            onClick: close
          }, [
            _createVNode(_component_v_icon, { size: "18" }, {
              default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                _createTextVNode("mdi-close", -1)
              ]))]),
              _: 1
            })
          ], 8, _hoisted_6)
        ]),
        _createElementVNode("div", _hoisted_7, [
          (rows.value.length || loading.value || loadError.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_8, " 임금 마감에는 현원 직원의 주민번호와 입사일이 필요합니다. 비어 있는 항목을 입력하고 저장한 뒤 마감해 주세요. "))
            : _createCommentVNode("", true),
          (loading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, "불러오는 중…"))
            : (loadError.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(loadError.value), 1))
              : (!rows.value.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, " 미등록자가 모두 등록되었습니다. 「마감 계속하기」를 눌러 주세요. "))
                : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createElementVNode("table", _hoisted_13, [
                      _cache[6] || (_cache[6] = _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("th", { class: "col-name" }, "성명"),
                          _createElementVNode("th", { class: "col-job" }, "직종"),
                          _createElementVNode("th", { class: "col-ssn" }, "주민번호 뒷자리"),
                          _createElementVNode("th", { class: "col-join" }, "입사일"),
                          _createElementVNode("th", { class: "col-save" })
                        ])
                      ], -1)),
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rows.value, (row) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: rowKey(row)
                          }, [
                            _createElementVNode("td", _hoisted_14, [
                              _createElementVNode("span", _hoisted_15, _toDisplayString(row.clci_name || '-'), 1),
                              _createElementVNode("span", _hoisted_16, _toDisplayString(formatBirth(row.clci_birth_date)), 1)
                            ]),
                            _createElementVNode("td", _hoisted_17, _toDisplayString(row.clci_job_type || '-'), 1),
                            _createElementVNode("td", _hoisted_18, [
                              (row.clci_has_ssn_back)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_19, "등록됨"))
                                : (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                    _createElementVNode("span", _hoisted_21, _toDisplayString(formatSsnFront(row.clci_birth_date)), 1),
                                    _cache[5] || (_cache[5] = _createElementVNode("span", { class: "ssn-dash" }, "-", -1)),
                                    _withDirectives(_createElementVNode("input", {
                                      "onUpdate:modelValue": ($event: any) => ((drafts[rowKey(row)]) = $event),
                                      class: "ssn-back-input",
                                      type: "text",
                                      maxlength: "7",
                                      inputmode: "numeric",
                                      autocomplete: "off",
                                      placeholder: "7자리",
                                      disabled: saving.value,
                                      onInput: ($event: any) => (onSsnInput(rowKey(row), $event)),
                                      onKeydown: _withKeys(_withModifiers(($event: any) => (saveOne(row)), ["prevent"]), ["enter"])
                                    }, null, 40, _hoisted_22), [
                                      [_vModelText, drafts[rowKey(row)]]
                                    ])
                                  ]))
                            ]),
                            _createElementVNode("td", _hoisted_23, [
                              (hasJoinDate(row.clci_work_start_date))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(formatBirth(row.clci_work_start_date)), 1))
                                : (_openBlock(), _createBlock(YmdDateInput, {
                                    key: 1,
                                    modelValue: joinDrafts[rowKey(row)],
                                    "onUpdate:modelValue": ($event: any) => ((joinDrafts[rowKey(row)]) = $event),
                                    disabled: saving.value
                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"]))
                            ]),
                            _createElementVNode("td", _hoisted_25, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "ssn-save-btn",
                                disabled: saving.value,
                                onClick: ($event: any) => (saveOne(row))
                              }, " 저장 ", 8, _hoisted_26)
                            ])
                          ]))
                        }), 128))
                      ])
                    ])
                  ]))
        ]),
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("button", {
            type: "button",
            class: "btn-secondary",
            disabled: saving.value,
            onClick: close
          }, " 닫기 ", 8, _hoisted_28),
          (!loading.value && !loadError.value && !rows.value.length)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "btn-primary",
                disabled: saving.value,
                onClick: continueMagam
              }, " 마감 계속하기 ", 8, _hoisted_29))
            : (_openBlock(), _createElementBlock("button", {
                key: 1,
                type: "button",
                class: "btn-primary",
                disabled: saving.value || !saveableCount.value,
                onClick: saveAll
              }, [
                (saving.value)
                  ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                      key: 0,
                      indeterminate: "",
                      size: "14",
                      width: "2",
                      color: "white"
                    }))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode("입력한 " + _toDisplayString(saveableCount.value) + "명 저장", 1)
                    ], 64))
              ], 8, _hoisted_30))
        ])
      ])
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})